import React from 'react';

import NwIcon from '@components/Gui/NwIcon';
import NwUpload from '@components/Gui/NwUpload';

import { getArtMediaDocumentId, getArtStoredMediaUrl } from '@containers/Art/ArtDocuments';
import { ARTICLE_MEDIA_SOURCE } from '@containers/Art/Articles/Articles.constants';
import { makeArticleMedia } from '@containers/Art/Articles/ArticlesRepository';
import ArtMediaSourceFields from '@containers/Art/ArtMediaSourceFields';

import ArticleMediaPreview from './ArticleMediaPreview';
import { ArticleMediaHint } from './ArticleMediaPreview.styles';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ArticleEditorMediaBlock = ({
    block,
    column,
    row,
    onApplyEmbedMedia,
    onChangeEmbedInput,
    onChangeMediaSource,
    onChangeNetwalkModel,
    onOpenMediaSelector,
    onSelectUploadedMedia,
    onUploadMediaEnd,
    uploadedSelectorZIndex,
}) => {
    const media = block.Media || makeArticleMedia();
    const documentId = getArtMediaDocumentId(media);
    const mediaUrl = getArtStoredMediaUrl(media);
    const mediaSource = media.Source || media.source || ARTICLE_MEDIA_SOURCE.UPLOAD;
    const hasMedia = Boolean(mediaUrl || documentId);

    // svuotare il blocco e' un cambio sorgente verso quella corrente: makeArticleMedia
    // riparte da zero tenendo solo Source, che e' esattamente quello che serve qui
    const handleRemoveMedia = () => onChangeMediaSource(row.ID, column.ID, block.ID, mediaSource);

    const mediaDropzone = (
        <div className="nw-dropzone-wrap">
            <NwUpload
                dragDrop
                localUpload
                maxCount={1}
                maxSize={200}
                multiple={false}
                showList={false}
                types={['image', 'video']}
                onUploadEnd={onUploadMediaEnd(row.ID, column.ID, block.ID)}
            >
                <div className="nw-dropzone">
                    <NwIcon icon={byPrefixAndName.fasl['arrow-down-to-line']} />
                    <strong>Drop an image or video here</strong>
                    <small>or click to browse your computer</small>
                </div>
            </NwUpload>
        </div>
    );

    return (
        <>
            <ArticleMediaPreview
                emptyState={mediaDropzone}
                hasMedia={hasMedia}
                media={media}
                onRemove={handleRemoveMedia}
            />
            {hasMedia ? (
                <ArticleMediaHint>
                    Remove the current media to choose a different photo, video or Vimeo/YouTube video.
                </ArticleMediaHint>
            ) : (
                <ArtMediaSourceFields
                    embedUrl={media.EmbedInput || (mediaSource === ARTICLE_MEDIA_SOURCE.EMBED ? mediaUrl || '' : '')}
                    hideUploadControl
                    netwalkModelId={media.ModelId}
                    source={mediaSource}
                    onApplyEmbed={() => onApplyEmbedMedia(row.ID, column.ID, block.ID, media.EmbedInput || mediaUrl)}
                    onEmbedUrlChange={(value) => onChangeEmbedInput(row.ID, column.ID, block.ID, value)}
                    onNetwalkModelChange={(modelId) => onChangeNetwalkModel(row.ID, column.ID, block.ID, modelId)}
                    onSelectNetwalkMedia={() =>
                        onOpenMediaSelector({
                            blockId: block.ID,
                            columnId: column.ID,
                            modelId: media.ModelId,
                            rowId: row.ID,
                        })
                    }
                    onSelectUploadedMedia={(upload) => onSelectUploadedMedia(row.ID, column.ID, block.ID, upload)}
                    onSourceChange={(source) => onChangeMediaSource(row.ID, column.ID, block.ID, source)}
                    uploadedSelectorTitle="Select article media"
                    uploadedSelectorZIndex={uploadedSelectorZIndex}
                />
            )}
        </>
    );
};

export default ArticleEditorMediaBlock;
